<template>
  <Dialog :visible="isModalForMergeOpen" :closable="false" :modal="true" :style="{ width: '1150px' }">
    <template #header>
      <div class="d-flex align-items-center w-100 border-bottom border-3 pb-3">
        <div class="me-auto">
          <h3 class="mb-0">Helyiségek összevonása</h3>
        </div>
        <div class="d-flex align-items-center text-center gap-3 me-4">
          <div class="border-start border-end border-3 px-3">
            <h1 class="text-sm text-uppercase">Kijelölt helyiségek</h1>
            <span class="badge bg-success">{{ selectedareas.length }}</span>
          </div>
          <div class="border-start border-end border-3 px-3">
            <h1 class="text-sm text-uppercase">Összevont terület</h1>
            <span class="badge bg-danger">{{ form.gross_floor_space }} m²</span>
          </div>
        </div>
        <div class="d-flex flex-column gap-1">
            <Button label="Mégse"  text class="bg-danger py-1 text-white" @click="hideDialog" />
            <Button label="Mentés" :loading="loading" :disabled="isSaveDisabled" class="py-1" @click="saveArea" />
        </div>
      </div>
    </template>

    <div class="row ms-2 mt-4">
      <div class="col-2">
        <label class="block font-bold" style="display: block; font-weight: 700;">Bérlemény azonostó</label>
      </div>
      <div class="col-2">
        <label class="block font-bold" style="display: block; font-weight: 700;">Bérlemény hasznosítás</label>
      </div>
      <div class="col-2">
        <label class="block font-bold" style="display: block; font-weight: 700;">Helyiség száma</label>
      </div>
      <div class="col-2">
        <label class="block font-bold" style="display: block; font-weight: 700;">Nettó terület</label>
      </div>
      <div class="col-2">
        <label class="block font-bold" style="display: block; font-weight: 700;">Bruttó terület</label>
      </div>
      <div class="col-2" />
    </div>

    <div v-for="(area, index) in selectedareas" :key="'selected-' + index" class="px-4">
      <div class="row py-2">
        <div class="col-2">
          <InputText 
            :value="area.identifier"
            disabled
            fluid
          />
        </div>
        <div class="col-2">
          <FormDropdown 
            v-model="area.utilization_id"
            :disabled="true"
            :possible-values="areaUtilizationList"
            placeholder="Kötelező"
            class="w-full"
          />
        </div>
        <div class="col-2">
          <FormDropdown 
            v-model="area.area_numbers_id"
            :disabled="true"
            :possible-values="areaNumbersList"
            placeholder="Kötelező"
            class="w-full"
          />
        </div>
        <div class="col-2">
          <InputText 
            :value="area.net_floor_space"
            disabled
            fluid
          />
        </div>
        <div class="col-2">
          <InputText 
            :value="area.gross_floor_space"
            disabled
            fluid
          />
        </div>
      </div>
    </div>

    <div class="px-4 mt-4 pt-4">
      <div class="row py-2">
        <div class="col-2">
          <InputText 
            id="identifier" 
            v-model.trim="form.identifier" 
            required="true"
            placeholder="(Kötelező)" 
            autofocus 
            fluid
          />
          <small v-if="submitted && !form.identifier" class="text-red-500">Azonostó szükséges.</small>
        </div>
        <div class="col-2">
          <Select 
            id="rental_utilization_id" 
            v-model="form.rental_utilization_id"
            :options="areaRentalUtilizationList"
            optionLabel="name" 
            optionValue="id" 
            placeholder="(Kötelező)" 
            fluid
          />
          <small v-if="submitted && !form.area_functions_id" class="text-red-500">Funkció szükséges.</small>
        </div>
        <div class="col-2">
          <Select 
            id="area_numbers_id" 
            v-model="form.area_numbers_id"
            :options="areaNumbersListSelect"
            optionLabel="name" 
            optionValue="id" 
            placeholder="(Kötelező)" 
            fluid 
          />
          <small v-if="submitted && !form.area_numbers_id" class="text-red-500">Helyiségszám szükséges.</small>
        </div>
        <div class="col-2">
          <InputText 
            id="net_floor_space" 
            v-model.trim="form.net_floor_space" 
            required="true" 
            placeholder="(Kötelező)" 
            autofocus 
            fluid
          />
          <small v-if="submitted && !form.net_floor_space" class="text-red-500">Nettó terület szükséges.</small>
        </div>
        <div class="col-2">
          <InputText 
            id="gross_floor_space" 
            v-model.trim="form.gross_floor_space" 
            required="true" 
            placeholder="(Kötelező)" 
            autofocus 
            fluid
          />
          <small v-if="submitted && !form.gross_floor_space" class="text-red-500">Bruttó terület szükséges.</small>
        </div>
        <div class="col-2 d-table d-flex justify-content-center align-items-end pb-2">
          <span aria-hidden="true" class="text-xs font-weight-bold d-table-cell align-middle d-flex justify-content-center align-items-center gap-2">
            <i class="fas fa-list cursor-pointer me-3 fa-2x" @click="mergedAreaDialog = true"></i>
          </span>
        </div>
      </div>
    </div>

    <Dialog v-model:visible="mergedAreaDialog" @update:visible="mergedAreaDialog = false" :modal="true" :style="{ width: '450px' }" header="Összevont helyiség adatai">
      <div class="flex flex-col" style="display: flex;flex-direction: column; gap: 1rem;">
        <div>
          <label for="area_buildings_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Épületszám</label>
          <Select 
            id="area_buildings_id"
            v-model="form.area_buildings_id" 
            :options="buildingsList"
            optionLabel="name" 
            optionValue="id" 
            placeholder="(Kötelező)" 
            fluid 
          />
        </div>
        <div>
          <label for="area_positions_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Pozíció</label>
          <Select 
            id="area_positions_id"
            v-model="form.area_positions_id"
            :options="filteredAreaPositionsList"
            optionLabel="name" 
            optionValue="id" 
            placeholder="(Kötelező)" 
            fluid
          />
        </div>
        <div>
          <label for="area_positions_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Funkció</label>
          <Select 
            id="area_functions_id" 
            v-model="form.area_functions_id"
            :options="areaFunctionsListSelect"
            optionLabel="name" 
            optionValue="id" 
            placeholder="(Kötelező)" 
            fluid
          />
          <small v-if="submitted && !form.area_functions_id" class="text-red-500">Funkció szükséges.</small>
        </div>
        <div>
          <label for="lot_number" class="block font-bold mb-3" style="display: block; font-weight: 700;">Helyrajzi szám</label>
          <InputText 
            id="lot_number" 
            v-model.trim="form.lot_number"
            required="true"
            autofocus 
            fluid 
            placeholder="(Kötelező)" 
            disabled
          />
          <small v-if="submitted && !form.lot_number" class="text-red-500">Helyrajzi szám szükséges.</small>
        </div>
        <div>
          <label for="height" class="block font-bold mb-3" style="display: block; font-weight: 700;">Magasság</label>
          <InputText 
            id="height" 
            v-model.trim="form.height"
            required="true" 
            placeholder="(Opcionális)" 
            autofocus 
            fluid 
          />
          <small v-if="submitted && !form.height" class="text-red-500">Magasság szükséges.</small>
        </div>
        <div >
          <label for="area_floor_coverings_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Burkolat</label>
          <Select 
            id="area_floor_coverings_id" 
            v-model="form.area_floor_coverings_id"
            :options="areaFloorCoveringsList"
            optionLabel="name" 
            optionValue="id" 
            placeholder="(Kötelező)" 
            fluid
          />
        </div>
        <div class="pb-4">
          <label for="wall_structure_id" class="block font-bold mb-3" style="display: block; font-weight: 700;">Falszerkezet</label>
          <Select 
            id="wall_structure_id" 
            v-model="form.wall_structure_id"
            :options="areaWallStructuresList"
            optionLabel="name" 
            optionValue="id" 
            placeholder="(Opcionális)" 
            fluid
          />
        </div>
      </div>
      <template #footer>
        <Button label="Kész" icon="pi pi-check" @click="mergedAreaDialog = false" />
      </template>
    </Dialog>
  </Dialog>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from "vue";
import { useStore } from "vuex";
import showSwal from "../../../../mixins/showSwal";
import FormDropdown from "../../../../components/FormDropdown.vue";

const props = defineProps({
  isModalForMergeOpen: Boolean,
  selectedareas: Object,
  realestateId: String,
});

const emit = defineEmits(["close"]);
const hideDialog = () => {
  emit("close");
};

const store = useStore();
const buildingsList = computed(() => store.getters["buildings/getBuildingsData"] || []);
const areaPositionsList = computed(() => store.getters["positions/getPositionsData"] || []);
const areaFloorCoveringsList = computed(() => store.getters["coverings/getCoveringsData"] || []);
const areaWallStructuresList = computed(() => store.getters["wallstructures/getWallStructuresData"] || []);
const areaNumbersListSelect = computed(() => store.getters["areanumbers/getAreanumbersData"] || []);
const areaFunctionsListSelect = computed(() => store.getters["afunctions/getFunctionsData"] || []);
const areaRentalUtilizationList = computed(() => store.getters["rentalutilization/getRentalUtilizationData"] || []);

const areaUtilizationList = computed(() => {
  const list = store.getters["rentalutilization/getRentalUtilizationData"] || [];
  return list.map(item => ({
    value: item.id.toString(),
    label: item.name
  }));
});

const areaNumbersList = computed(() => {
  const list = store.getters["areanumbers/getAreanumbersData"] || [];
  return list.map(item => ({
    value: item.id.toString(),
    label: item.name
  }));
});

const filteredAreaPositionsList = computed(() => {
  return areaPositionsList.value.filter(areaPosition =>
    props.selectedareas.some(area =>
      area.area_position.some(p => p.id == areaPosition.id)
    )
  );
});

const submitted = ref(false);
const loading = ref(false);
const mergeIds = ref(null);
const areaDialog = ref(false);
const mergedAreaDialog = ref(false);

const form = ref({
    id: null, 
    identifier: "",
    realestate_id: "",
    area_buildings_id: "", 
    area_numbers_id: "", 
    lot_number: "",
    area_positions_id: "",
    rental_utilization_id: "",
    area_functions_id: "", 
    net_floor_space: 0,
    gross_floor_space: 0, 
    height: 0, 
    area_floor_coverings_id: "",
    wall_structure_id: "",
});

watch(() => props.selectedareas, (newVal) => {
  if (newVal && newVal.length > 0) {
    const selectedArea = newVal[0];
    form.value.lot_number = selectedArea.lot_number || "";
    
    const totalNetFloorSpace = newVal.reduce((sum, area) => {
      return sum + parseFloat(area.net_floor_space || 0);
    }, 0);

    const totalGrossFloorSpace = newVal.reduce((sum, area) => {
      return sum + parseFloat(area.gross_floor_space || 0);
    }, 0);

    const totalHeight = newVal.reduce((sum, area) => {
      return sum + parseFloat(area.height || 0);
    }, 0);
    
    form.value.net_floor_space = totalNetFloorSpace;
    form.value.gross_floor_space = totalGrossFloorSpace;
    const averageHeight = totalHeight / newVal.length;
    form.value.height = averageHeight.toFixed(2);
    
    mergeIds.value = newVal.map((area) => area.id);
  }
}, 
{ immediate: true });

const deleteSelectedAreas = async () => {
  try {
    mergeIds.value.forEach(async (id) => {
      await store.dispatch("areas/deleteArea", id);
    });
    emit("removeAreas", mergeIds.value);
    mergeIds.value = null;

  } catch (error) {
    console.log('Error in deleting a merged areas:', error);
  }
};

const saveArea = async () => {
  submitted.value = true;
  loading.value = true;
  form.value.realestate_id = props.realestateId;
  try {
    const areaId = await store.dispatch("areas/addArea", form.value);
    form.value.id = areaId.toString();
    await deleteSelectedAreas();
    emit("updateAreas", form.value);
    loading.value = false;
    showSwal.methods.showSwal({
      type: "success",
      message: "Sikeresen összevonta a helyiségeket!",
      width: 500
    });
    emit("close");
    
  } catch (error) {
    console.log('Error in saving the merged area:', error);
    showSwal.methods.showSwal({
      type: "error",
      message: "Valami hiba történt!",
      width: 500
    });
  }
};
</script>